'use client'

import { useEffect } from 'react'
import { useAlternateSlugsStore, AlternateUrls } from '@/lib/context/alternateSlugsContext'

interface Props {
  /** Pre-computed URLs for each language */
  alternateUrls: AlternateUrls
}

export function SetAlternateUrls({ alternateUrls }: Props) {
  const { setAlternateUrls, clearAlternateUrls } = useAlternateSlugsStore()

  useEffect(() => {
    setAlternateUrls(alternateUrls)

    return () => {
      clearAlternateUrls()
    }
  }, [alternateUrls, setAlternateUrls, clearAlternateUrls])

  return null
}
